import React, { useState } from 'react';
const OfferPlannerModalContent = (props) => {
    if (!props.items || !props.items.length) {
        return React.createElement("div", null, "No Items to Display");
    }
    return props.items.map((item, itemIndex) => {
        return (React.createElement("tr", null, props.renderers.map((renderer, rendererIndex) => {
            return (React.createElement("td", { className: `${rendererIndex !== props.renderers.length - 1 ? 'pr-10' : ''} text-center whitespace-nowrap` }, renderer.render(item, props.setItems, props.offerPlanners, props.offerPlannersIndex, props.setConfirmationModal, props.offerOrAssignProp)));
        })));
    });
};
export default OfferPlannerModalContent;
